var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkelpAwardsAch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.37 93.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e9aa21;}.cls-2{fill:#fff;}.cls-3{opacity:.65;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.06,
    y: 3.86,
    width: 85.85,
    height: 85.85,
    rx: 5.1,
    ry: 5.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m88.8,5.42c1.95,0,3.54,1.59,3.54,3.54v75.64c0,1.95-1.59,3.54-3.54,3.54H13.16c-1.95,0-3.54-1.59-3.54-3.54V8.96c0-1.95,1.59-3.54,3.54-3.54h75.64m0-1.56H13.16c-2.82,0-5.1,2.29-5.1,5.1v75.64c0,2.82,2.29,5.1,5.1,5.1h75.64c2.82,0,5.1-2.29,5.1-5.1V8.96c0-2.82-2.29-5.1-5.1-5.1h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m64.33,24.58v-6.49h-26.7v6.49h-5.95v8.05c0,3.5,2.64,6.37,6.03,6.79.4,5.91,3.69,10.68,8.72,12.48l-1.5,9.53h-5.57c-.43,0-.8.3-.9.72l-2.81,12.19c-.06.27,0,.56.18.78.17.22.44.35.72.35h28.87c.28,0,.55-.13.72-.35.17-.22.24-.51.18-.78l-2.81-12.19c-.1-.42-.47-.72-.9-.72h-5.57l-1.47-9.54c5.01-1.81,8.29-6.57,8.68-12.47,3.39-.42,6.03-3.29,6.03-6.79v-8.05h-5.95Zm-30.81,8.05v-6.21h4.1v11.15c-2.33-.43-4.1-2.49-4.1-4.94Zm28.34,30.65l2.39,10.34h-26.55l2.39-10.34h21.78Zm-7.59-12.91l-.78.23,1.67,10.84h-8.37l1.55-9.95v-.92s-.67-.19-.67-.19c-4.99-1.46-8.21-6.22-8.21-12.14v-18.29h23.01v18.29c0,5.92-3.22,10.68-8.21,12.14Zm14.16-17.74c0,2.46-1.77,4.51-4.1,4.94v-11.15h4.1v6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m50.98,26.37c-3.65,0-6.61,2.97-6.61,6.61s2.97,6.61,6.61,6.61,6.61-2.97,6.61-6.61-2.97-6.61-6.61-6.61Zm0,11.38c-2.63,0-4.77-2.14-4.77-4.77s2.14-4.77,4.77-4.77,4.77,2.14,4.77,4.77-2.14,4.77-4.77,4.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46,
    y: 67.53,
    width: 9.97,
    height: 1.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkelpAwardsAch);
export default __webpack_public_path__ + "static/media/SKELP_AwardsAch.78a4f24043d7c292ec31611b5769e10b.svg";
export { ForwardRef as ReactComponent };